import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-start" }
const _hoisted_2 = { class: "form-group me-2" }
const _hoisted_3 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_toggler = _resolveComponent("toggler")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Margine inferiore",
            text: "Margine inferiore"
          })
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.marginBottom) = $event))
        }, _cache[3] || (_cache[3] = [
          _createStaticVNode("<option value=\"1\">1</option><option value=\"2\">2</option><option value=\"3\">3</option><option value=\"4\">4</option><option value=\"5\">5</option>", 5)
        ]), 512), [
          [_vModelSelect, _ctx.localValue.marginBottom]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Larghezza completa",
            text: "Larghezza completa"
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_toggler, {
            mini: true,
            modelValue: _ctx.localValue.isFullWidth,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.isFullWidth) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentType), {
      modelValue: _ctx.localValue,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue) = $event))
    }, null, 8, ["modelValue"]))
  ]))
}